<template>
  <div>
    <div class="page-title">New Tag</div>
    <Form v-if="form" v-model="form" :submit="create" btnText="Add Tag" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.blog-tag.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Tag",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.BlogTag.new();
      this.form = data;
    },
    async create() {
      await this.$api.BlogTag.create(this.form);
      this.$router.push("/blog");
    },
  },
};
</script>

<style></style>
